import { render, staticRenderFns } from "./tableActionPopover.vue?vue&type=template&id=ff421de2&scoped=true&"
import script from "./tableActionPopover.vue?vue&type=script&lang=js&"
export * from "./tableActionPopover.vue?vue&type=script&lang=js&"
import style0 from "./tableActionPopover.vue?vue&type=style&index=0&id=ff421de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff421de2",
  null
  
)

export default component.exports